/**
 * Feature flags.
 *
 * Server-authoritative checkout (docs/server-checkout-migration.md):
 * CRA inlines env vars at build time and deploys are static, so the build-time
 * default (`REACT_APP_SERVER_CHECKOUT`) can be overridden at runtime per
 * browser via localStorage — `feature.serverCheckout` set to "on" or "off".
 */
export const SERVER_CHECKOUT_FLAG_KEY = "feature.serverCheckout";

export function isServerCheckoutEnabled(): boolean {
  try {
    const override = window.localStorage.getItem(SERVER_CHECKOUT_FLAG_KEY);
    if (override === "on") return true;
    if (override === "off") return false;
  } catch {
    // localStorage unavailable (privacy mode / SSR) — fall through to env default
  }
  return process.env.REACT_APP_SERVER_CHECKOUT === "true";
}
